/*
 *
 * RubiconePopup
 *
 * @version 1.0.0
 * @author Giorgia Cuozzo
 * @since 04-Feb-2025
 */

import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  continueOnMos: <PortalMessage id='t.app.continueOnMos' defaultMessage='Continua su Nexi Shop' />,
  continueOnMosDescription: (offerType) => (
    <PortalMessage
      id='t.app.continueOnMosDescription'
      defaultMessage='Continua su Nexi Shop e segui le istruzioni riportate per assicurarti l’{{offerType}}.'
      values={{ offerType }}
    />
  ),
  continue: <PortalMessage id='t.app.continue' defaultMessage='Continua' />
}

export default formattedMessage
